import zIndex from 'fe-design-base/styles/zIndex';

import { SCRIM_DEFAULT_ZINDEX } from 'components/ScrimWrapper';

export const CONTAINER_STYLE = { overflow: 'hidden' };
export const MENU_STYLE = { zIndex: zIndex.zindexMessengerViewMenu };
export const MENU_STYLE_SCRIM_OPENED = { zIndex: SCRIM_DEFAULT_ZINDEX + 1 };
export const MESSENGER_SCRIM_EVENT_NAME = 'covid_scrim_messenger_view';
